<div class="ocp" *ngIf="(items$ | async) as items">
  <section class="ocp__card" *ngIf="items.length > 0" aria-live="polite">
    <header class="ocp__head" (click)="collapsed = !collapsed">
      <div class="ocp__badge" [class.ocp__badge--busy]="(headline$ | async)?.busy">
        <mat-icon>{{ (headline$ | async)?.busy ? 'auto_awesome' : 'task_alt' }}</mat-icon>
      </div>
      <div class="ocp__head-text">
        <strong>{{ (headline$ | async)?.title }}</strong>
        <span>{{ (headline$ | async)?.subtitle }}</span>
      </div>
      <button type="button" class="ocp__ghost" *ngIf="hasFinished$ | async" (click)="clearFinished(); $event.stopPropagation()" title="Quitar las terminadas" aria-label="Quitar las terminadas">
        <mat-icon>done_all</mat-icon>
      </button>
      <mat-icon class="ocp__chevron">{{ collapsed ? 'expand_less' : 'expand_more' }}</mat-icon>
    </header>

    <ul class="ocp__list" *ngIf="!collapsed">
      <li class="ocp__item" *ngFor="let item of items; trackBy: trackByUid" [ngClass]="'ocp__item--' + info(item.stage).tone">
        <div class="ocp__item-top">
          <div class="ocp__file-icon"><mat-icon>{{ info(item.stage).icon }}</mat-icon></div>
          <div class="ocp__item-text">
            <span class="ocp__name" [title]="item.name">{{ item.name }}</span>
            <span class="ocp__status">{{ info(item.stage).title }}</span>
          </div>
          <button type="button" class="ocp__ghost ocp__ghost--dark" *ngIf="!isActive(item.stage)" (click)="dismiss(item)" title="Quitar" aria-label="Quitar">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="ocp__bar" *ngIf="isActive(item.stage)">
          <div class="ocp__bar-fill" [style.width.%]="info(item.stage).percent"></div>
        </div>

        <ol class="ocp__steps" *ngIf="isActive(item.stage)">
          <li *ngFor="let step of steps; let i = index" class="ocp__step" [ngClass]="'ocp__step--' + stepState(item, i)">
            <span class="ocp__dot"></span>
            <span class="ocp__step-label">{{ step }}</span>
          </li>
        </ol>

        <p class="ocp__hint">{{ info(item.stage).hint }}</p>

        <button type="button" class="ocp__action" *ngIf="info(item.stage).action" (click)="go(item)">
          {{ info(item.stage).action.label }}
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </li>
    </ul>
  </section>
</div>
